module.exports = __webpack_public_path__ + "img/FF_Info_Game_4.7f2dc739.png";